import { z } from 'zod';

export const ocrProcessingStatusSchema = z.enum(['pending', 'processing', 'completed', 'failed']);
export const ocrReturnFormatSchema = z.enum(['full', 'minimal', 'custom']);

export const processOcrInputSchema = z.object({
  consentId: z.string().uuid().optional(),
  returnFormat: ocrReturnFormatSchema.default('full'),
  minConfidence: z.number().int().min(0).max(100).default(0),
});

export const ocrRequestQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  limit: z.coerce.number().int().min(1).max(100).default(20),
  status: ocrProcessingStatusSchema.optional(),
  fromDate: z.string().datetime().optional(),
  toDate: z.string().datetime().optional(),
});

// Image validation constants
export const MAX_IMAGE_SIZE = 10 * 1024 * 1024; // 10MB
export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp'] as const;
export const ALLOWED_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.webp'] as const;

export type OcrRequestQuery = z.infer<typeof ocrRequestQuerySchema>;
